import { FC } from 'react';

import { TemplateBadge } from 'entities/application/ui/TemplateBadge/TemplateBadge';
import {
	BadgeContainerStyled,
	HeaderContainerStyled,
} from 'entities/application/ui/TemplateHeader/TemplateHeader.styles';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpTitle } from 'shared/ui/MpTitle';

interface Props {
	name: string;
	description: string;
}

export const TemplateHeader: FC<Props> = ({ name, description }) => (
	<>
		<HeaderContainerStyled>
			<MpTitle level={2}>{name}</MpTitle>
			<BadgeContainerStyled>
				<TemplateBadge />
			</BadgeContainerStyled>
		</HeaderContainerStyled>
		<MpParagraph>{description}</MpParagraph>
	</>
);
